/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.Memberships {
    "use strict";
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import AccruedServiceSharingEnum = Meevo.Model.AccruedServiceSharingEnum;
    import DefinedUserTypeEnum = Meevo.Model.DefinedUserTypeEnum;
    import MemberShipType = Meevo.Model.MembershipType;
    import AutoRenewTypeEnum = Meevo.Model.AutoRenewTypeEnum;
    import BillingTypeEnum = Meevo.Model.BillingTypeEnum;
    import FreezeSettingEnum = Meevo.Model.FreezeSettingEnum;
    import MembershipLengthEnum = Meevo.Model.MembershipLengthEnum;

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Membership> {
        public showEnrollmentPackageDropdown = {
            primary: false,
            secondary: false
        };
        public showRecurringPackageDropdown = {
            primary: false,
            secondary: false
        };
        public showRenewalPackageDropdown = {
            primary: false,
            secondary: false
        };
        public enrollmentPackage: any;
        public recurringPackage: any;
        public renewalPackage: any;
        private _businessTypeFilter: {
            onlyId: string
        };
        private _freezeFees: Array<Model.IMembershipFreezeSetting>;

        public membershipTypeDetail: MemberShipType | any;
        public membershipTypeCriteria = {
            coFilterByLocationId: null,
            includeActive: true,
            coBusinessTypeId: null,
        };

        public getMembershipTypeCriteria () {
            if (this.model && this.model.isEmployeeMembership === false) {
                this.membershipTypeCriteria['nonCounting'] = false;
            } else if (this.model && this.model.isEmployeeMembership === true) {
                this.membershipTypeCriteria['nonCounting'] = true;
            }
            return this.membershipTypeCriteria;
        }
        public disableEmployeeMembership: boolean = false;
        public isRenewalFeeMonthlyOverrided: boolean = false;
        public isMinRenewalFeeMonthlyOverrided: boolean = false;
        public isPifRenewalFeeOverrided: boolean = false;
        public isMinPifRenewalFeeOverrided: boolean = false;
        public unlimitedServices: boolean;
        public showUnlimitedServiceExpire: boolean;
        public unlimitedServicesList: any = [];
        public securityKeys = Meevo.Components.Common.SecurityKeys;
        public isOnlineMembershipSalesDeny: boolean;
        public charLimit: number = 2000;

        /*
        * Temporarily field for hiding Defined User Type dropdown, min and max user selection.
        * (Related to user story 36568)
        */
        public areFieldsTemporarilyHidden: boolean = true;

        private _accruedServiceSharingList = {
            'No Sharing': AccruedServiceSharingEnum.NoSharing,
            // 'Only Defined Users': AccruedServiceSharingEnum.OnlyDefinedUsers,
            // 'Family Only': AccruedServiceSharingEnum.FamilyOnly,
            'Anyone': AccruedServiceSharingEnum.Anyone
        };

        private _accruedServiceSharingListTranslate = {
            [AccruedServiceSharingEnum.NoSharing]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_NOSHARING',
            [AccruedServiceSharingEnum.OnlyDefinedUsers]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_ONLYDEFINEDUSERS',
            [AccruedServiceSharingEnum.FamilyOnly]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_FAMILYONLY',
            [AccruedServiceSharingEnum.Anyone]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_ANYONE'
        };

        private _freezeSettingList = {
            [FreezeSettingEnum.AccruedServiceOnly]: 'LABEL_ACCRUED_SERVICES_ONLY',
            [FreezeSettingEnum.FullAccess]: 'LABEL_FULL_ACCESS?',
            [FreezeSettingEnum.MemberBenefitsOnly]: 'LABEL_MEMBER_BENEFITS_ONLY',
            [FreezeSettingEnum.NoAccess]: 'LABEL_NO_ACCESS',
        };

        private _definedUserType = {
            'Single': DefinedUserTypeEnum.Single,
            'Multi-User': DefinedUserTypeEnum.MultiUser,
            'Family': DefinedUserTypeEnum.Family,
            'Corporate': DefinedUserTypeEnum.Corporate
        };

        private _enrollmentPackageSettings: Array<Model.IMembershipPackageSettings> = [];
        private _recurringPackageSettings: Array<Model.IMembershipPackageSettings> = [];
        private _renewalPackageSettings: Array<Model.IMembershipPackageSettings> = [];

        public recurringPackageExceptionList: Array<Model.IMembershipPackageSettings> = [];
        public renewalPackageExceptionList: Array<Model.IMembershipPackageSettings> = [];

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {
            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                null,params.sectionSecurityKey);

            this.params.securityChecker.checkSecurityKey(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_OVERRIDEREACTIVATIONDATE)
                .then((securityCode: Meevo.Model.SecurityAccessEnum) => {
                    this.isOnlineMembershipSalesDeny = securityCode !== Meevo.Model.SecurityAccessEnum.Grant;
                });

            this.buildFreezeFees();
        }

        createSectionModelInstance(postAdd: (data: any)=>any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = <Model.Membership>data;

                if (this.areFieldsTemporarilyHidden) {
                    this.model.definedUserTypeEnum = DefinedUserTypeEnum.Single;
                    this.model.minShareUser = this.model.maxShareUser = 0;
                }
            });
            this.mapPackageSettings();
            this.buildFreezeFees();
        }

        createSectionModelCopy(): Model.Membership {
            let item = <Model.Membership>(this.model);
            item.id = null;
            if (!item.isFreezeEnabled) {
                this.buildFreezeFees();
            }
            return item;
        }

        asyncValidationOnCreate(): ng.IPromise<any> {
            this.buildMemberPackageSettingsList();

            const membershipValidation = new MembershipValidationController(this.model, this.params.$translate);

            if (membershipValidation.listItemNames().length > 0) {
                return this.params.modalService.yellowConfirm(this.params.$translate.instant('MESSAGE_MEMBERSHIP_NOT_FULLY_SET', {
                    list: membershipValidation.listItemNamesCombined()
                }));
            }

            return this.params.$q.resolve();
        }

        /**
         * Prepare model for saving
         */
        public preSave(): void {
            if (!this.model) return;

            if (this.model.isEmployeeMembership) {
                this.model.isAvailableForOnlineSales = false;
            }

            this.showEnrollmentPackageDropdown.primary = false;
            this.showEnrollmentPackageDropdown.secondary = false;
            this.showRecurringPackageDropdown.primary = false;
            this.showRecurringPackageDropdown.secondary = false;
            this.showRenewalPackageDropdown.primary = false;
            this.showRenewalPackageDropdown.secondary = false;

            // reset unused variables
            if (this.model.accruedServiceSharingEnum === AccruedServiceSharingEnum.NoSharing) {
                this.model.sharingFee = 0;
            }

            if (!this.model.isLimitServiceSharingToSameClient) {
                this.model.limitNumberOfAccruedServiceForSharing = 0;
                this.model.limitNumberOfAccruedServiceForSharingPerMonth = 0;
            }

            if (!this.model.isLimitServiceSharingToAnyClient) {
                this.model.limitNumberOfAccruedServiceForSharingToAnyClient = 0;
                this.model.limitNumberOfMonthForServiceSharingToAnyClient = 0;
            }

            // update freeze fee settings model with locally built data
            this.model.membershipFreezeSettings.length = 0;
            if (this.model.isFreezeEnabled) {
                _.each(this._freezeFees, item => {
                    if (item.isEnabled) {
                        this.model.membershipFreezeSettings.push({
                            freezeSetting: item.freezeSetting,
                            fee: item.fee,
                            isPercent: item.isPercent
                        });
                    }
                })
            } else {
                this.model.minFreezeDays = 0;
                this.model.maxFreezeDays = 0;
            }

            if (this.model.autoRenewTypeEnum === AutoRenewTypeEnum.No) {
                this.model.membershipMemberSettings[0]['monthlyRenewalFee'] = 0;
                this.model.membershipMemberSettings[0]['minMonthlyRenewalFee'] = 0;
                this.model.membershipMemberSettings[0]['pifRenewalFee'] = 0;
                this.model.membershipMemberSettings[0]['minPIFRenewalFee'] = 0;
            }

            // build membership package settings
            this.buildMemberPackageSettingsList();
        }

        public get businessTypeFilter() {
            return this._businessTypeFilter;
        }

        /**
         * Model review
         */
        public sectionModelRetrieved(): void {
            if (!this.model) return;

            this.model.maxFreezeDays = this.model.maxFreezeDays <= 0 ? 1: this.model.maxFreezeDays;
            this.model.minFreezeDays = this.model.minFreezeDays <= 0 ? 1: this.model.minFreezeDays;
            this.model.membershipTypeDetail.isIncludedSaleConversionRatio = this.model.isIncludedSaleConversionRatio;
            this.mapFreezeFees();
            this.mapPackageSettings();
            this.checkIsSold();
            this.isFeeAutofilled();
            this.model.accruedServiceDaysToExpire = this.model.accruedServiceDaysToExpire || 30;
        }

        get accruedServiceSharingList() {
            return this._accruedServiceSharingList;
        }

        get definedUserType() {
            return this._definedUserType;
        }

        get accruedServiceSharingEnum(): any {
            return AccruedServiceSharingEnum;
        }

        get freezeFees() {
            return this._freezeFees;
        }

        get enrollmentPackageSettings() {
            return this._enrollmentPackageSettings;
        }

        get recurringPackageSettings() {
            return this._recurringPackageSettings;
        }

        get renewalPackageSettings() {
            return this._renewalPackageSettings;
        }

        /**
         * Create array of freeze fees settings
         * */
        private buildFreezeFees(): void {
            this._freezeFees = [
                {
                    freezeSetting: Model.FreezeSettingEnum.NoAccess,
                    fee: 0,
                    isPercent: false,
                    isEnabled: true,
                    displayName: this.params.$translate.instant('LABEL_NO_ACCESS')
                },
                {
                    freezeSetting: Model.FreezeSettingEnum.AccruedServiceOnly,
                    fee: 0,
                    isPercent: false,
                    isEnabled: false,
                    displayName: this.params.$translate.instant('LABEL_ACCRUED_SERVICES_ONLY')
                },
                {
                    freezeSetting: Model.FreezeSettingEnum.MemberBenefitsOnly,
                    fee: 0,
                    isPercent: false,
                    isEnabled: false,
                    displayName: this.params.$translate.instant('LABEL_MEMBER_BENEFITS_ONLY')
                },
                {
                    freezeSetting: Model.FreezeSettingEnum.FullAccess,
                    fee: 0,
                    isPercent: false,
                    isEnabled: false,
                    displayName: this.params.$translate.instant('LABEL_FULL_ACCESS?')
                }
            ];
        }

        /**
         * Map local freeze fee settings object with data from server
         * */
        private mapFreezeFees(): void {
            let noAccess: Model.IMembershipFreezeSetting = _.findWhere(this._freezeFees, {'freezeSetting': Model.FreezeSettingEnum.NoAccess});
            noAccess.isEnabled = false;

            _.each(this.model.membershipFreezeSettings, item => {
                let localFreezeFee: Model.IMembershipFreezeSetting = _.findWhere(this._freezeFees, {'freezeSetting': item.freezeSetting});

                if (localFreezeFee) {
                    localFreezeFee.fee = item.fee;
                    localFreezeFee.isPercent = item.isPercent;
                    localFreezeFee.isEnabled = true;
                }
            });
        }

        /**
         * Map membership package settings
         * */
        private mapPackageSettings(): void {
            this._enrollmentPackageSettings.length = 0;
            this._recurringPackageSettings.length = 0;
            this._renewalPackageSettings.length = 0;
            this.renewalPackageExceptionList = [];
            this.recurringPackageExceptionList = [];

            this.collectUnlimitedServicesIds().then(() => {
                this.unlimitedServicesList.forEach((item: any) => {
                    this.recurringPackageExceptionList.push(item);
                    this.renewalPackageExceptionList.push(item);
                });

                _.each(this.model.membershipPackageSettings, item => {
                    // id for exception-list in typeAHead
                    item.id = item.packageTypeId;

                    if (item.feeType === Model.FeeTypeEnum.Enrollment) {
                        this._enrollmentPackageSettings.push(item);
                    } else if (item.feeType === Model.FeeTypeEnum.Recurring) {
                        this._recurringPackageSettings.push(item);
                        this.recurringPackageExceptionList.push(item);
                    } else if (item.feeType === Model.FeeTypeEnum.Renewal) {
                        this._renewalPackageSettings.push(item);
                        this.renewalPackageExceptionList.push(item);
                    }
                });
                this.checkUnlimitedServices();
            });
        }

        /**
         * Create for server the proper array of package settings.
         * */
        private buildMemberPackageSettingsList(): void {
            this.model.membershipPackageSettings.length = 0;

            _.each(this.getPackageSettingsToSave(), (item: Model.IMembershipPackageSettings) => {
                this.model.membershipPackageSettings.push({
                    memberType: item.memberType,
                    feeType: item.feeType,
                    packageTypeId: item.packageTypeId,
                    isUnlimitedServices: item.isUnlimitedServices,
                    packageTypeDetail: {
                        id: item.packageTypeDetail.id,
                        displayName: item.packageTypeDetail.displayName
                    },
                });
            });
        }

        /**
         * Package settings that go to the server: the fee type the billing type doesn't use is left out.
         * */
        private getPackageSettingsToSave(): Array<Model.IMembershipPackageSettings> {
            let packageSettings = _.union(this._enrollmentPackageSettings, this._recurringPackageSettings, this._renewalPackageSettings);

            return _.filter(packageSettings, (item: Model.IMembershipPackageSettings) => {
                let isRenewalReccurringMembership = item.feeType === Model.FeeTypeEnum.Renewal && this.model.billingTypeEnum === BillingTypeEnum.RecurringPayments,
                    isReccurringPaidInFullMembership = item.feeType === Model.FeeTypeEnum.Recurring && this.model.billingTypeEnum === BillingTypeEnum.PaidInFull;

                return !(isRenewalReccurringMembership || isReccurringPaidInFullMembership);
            });
        }

        activate(): void {
            // Initialize model properties
            super.activate();
        }

        /**
         * Check if package have unlimitedServices
         * */
        public checkUnlimitedServices(isShowMessage: boolean = true) {
            this.unlimitedServices = false;
            this.showUnlimitedServiceExpire = false;
            _.each(_.union(this._enrollmentPackageSettings, this._recurringPackageSettings, this._renewalPackageSettings), item => {
                if (item.hasOwnProperty('isUnlimitedServices') && item.isUnlimitedServices) {

                    this.showUnlimitedServiceExpire = true;
                    if (this.model.accruedServiceSharingEnum === this._accruedServiceSharingList["Anyone"]) {

                        if (isShowMessage) this.params.modalService.warning("MESSAGE_WARNING_MEMBERSHIP_UNLIMITED_PACKAGES");
                        this.unlimitedServices = true;
                        this.model.accruedServiceSharingEnum = this._accruedServiceSharingList["No Sharing"];
                    }
                }
            });
        }

        /**
         * Validate if field is not last-selected
         * */
        public validateFeeAccessField(feeSetting: Model.IMembershipFreezeSetting) {
            if (_.pluck(this._freezeFees, 'isEnabled').indexOf(true) < 0) {
                feeSetting.isEnabled = true;
            }
        }


        /**
         * Add package to local created list
         * */
        public addToPackageSettingsArray(item, feeType: string, memberType: number) {
            // Set base value for package setting
            let packageSetting = {
                memberType: memberType,
                feeType: Model.FeeTypeEnum.Enrollment,
                isUnlimitedServices: item.isUnlimitedServices,
                packageTypeDetail: {
                    id: item.id,
                    displayName: item.displayName
                },
                packageTypeId: item.id,
                id: item.id
            }

            switch (feeType) {
                case 'enrollment':
                    packageSetting.feeType = Model.FeeTypeEnum.Enrollment;
                    this._enrollmentPackageSettings.push(packageSetting);
                    this.enrollmentPackage = null;

                    if (memberType === Model.MemberTypeEnum.Primary) {
                        this.showEnrollmentPackageDropdown.primary = !this.showEnrollmentPackageDropdown.primary;
                    } else {
                        this.showEnrollmentPackageDropdown.secondary = !this.showEnrollmentPackageDropdown.secondary;
                    }
                    break;
                case 'recurring':
                    packageSetting.feeType = Model.FeeTypeEnum.Recurring;
                    this._recurringPackageSettings.push(packageSetting);
                    this.recurringPackageExceptionList.push(packageSetting);

                    this.recurringPackage = null;

                    if (memberType === Model.MemberTypeEnum.Primary) {
                        this.showRecurringPackageDropdown.primary = !this.showRecurringPackageDropdown.primary;
                    } else {
                        this.showRecurringPackageDropdown.secondary = !this.showRecurringPackageDropdown.secondary;
                    }
                    break;
                case 'renewal':
                    packageSetting.feeType = Model.FeeTypeEnum.Renewal;
                    this._renewalPackageSettings.push(packageSetting);
                    this.renewalPackageExceptionList.push(packageSetting);
                    this.renewalPackage = null;

                    if (memberType === Model.MemberTypeEnum.Primary) {
                        this.showRenewalPackageDropdown.primary = !this.showRenewalPackageDropdown.primary;
                    } else {
                        this.showRenewalPackageDropdown.secondary = !this.showRenewalPackageDropdown.secondary;
                    }
                    break;
            }
            this.checkUnlimitedServices();
        }

        /**
         * Toggle button and dropdown state for 'Add Package' functionality
         * */
        public addPackageButtonState(memberType: number, feeType: string, toggleValue: boolean = false, disable: boolean = false): boolean {
            if (disable) {
                return false;
            }

            let packageDropdown: string;
            let memberTypeName: string;

            if (feeType === 'enrollment') {
                packageDropdown = 'showEnrollmentPackageDropdown';
            } else if (feeType === 'recurring') {
                packageDropdown = 'showRecurringPackageDropdown';
            } else if (feeType === 'renewal') {
                packageDropdown = 'showRenewalPackageDropdown';
            }

            if (memberType === Model.MemberTypeEnum.Primary) {
                memberTypeName = 'primary';
            } else {
                memberTypeName = 'secondary';
            }

            return toggleValue ? this[packageDropdown][memberTypeName] = !this[packageDropdown][memberTypeName] : this[packageDropdown][memberTypeName];
        }

        /**
         * Click remove icon
         * Remove package from List
         * @param item - item for delete
         * @param arr - list items
         * */
        public removePackage(item: any, arr: Array<any>, exceptionArr: Array<any> = undefined): void {
            let index = arr.indexOf(item);
            if (exceptionArr) {
                let exceptionIndex = exceptionArr.indexOf(item);
                if (exceptionIndex >= 0) {
                    exceptionArr.splice(exceptionIndex, 1);
                }
            }
            arr.splice(index, 1);
            this.checkUnlimitedServices();
        }

        /**
         * presave validation
         * if this function returning false, save will not be called
         * @returns {boolean}
         */
        public preSaveValidation(): boolean{
            if(this.model.isEmployeeMembership && this.model.membershipTypeDetail.isIncludedSaleConversionRatio){
                this.params.modalService.alert("MESSAGE_MEMBERSHIP_TYPE_COUNTING_ERROR");
                return false;
            }
            return true;
        }

        /**
         * True when this edit switches a stored active membership to inactive.
         * Only an edit counts: on Copy the backup is the source membership, and on Add it can be left over from an earlier edit.
         * */
        public isBeingDeactivated(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Editing
                && !!this.backup && this.backup.objectState !== ObjectStateEnum.Inactive && this.model.objectState === ObjectStateEnum.Inactive;
        }

        public get isCanAccruedServiceSharing() {
            return this.model ? this.model['accruedServiceSharingEnum'] === AccruedServiceSharingEnum.NoSharing : false;
        }


        public viewBenefits(template: any): ng.IPromise<any> {
            if (_.isEmpty(template)) {
                return;
            }

            let membershipModel = {
                accruedServiceSharing: this._accruedServiceSharingListTranslate[this.model['accruedServiceSharingEnum']],
                isCanAccruedServiceSharing: this.isCanAccruedServiceSharing,
                isFreezeEnabled: this.model.isFreezeEnabled,
                sharingFee: this.model.sharingFee,
                minFreezeDays: this.model.minFreezeDays,
                maxFreezeDays: this.model.maxFreezeDays,
                membershipFreezeSettings: this.model.membershipFreezeSettings,
            };

            _.each(membershipModel['membershipFreezeSettings'], (item: Model.IMembershipFreezeSetting) => {
                item.displayName = this._freezeSettingList[item.freezeSetting];
            });

            return this.dataService.getSectionById("memberBenefitTemplate", template.id, "", null)
                .then((data: any) => {
                    let enrollmentPackageIds = this.enrollmentPackageSettings.map((item) => {
                        return item.id;
                    });
                    let recurringPackageIds = this.recurringPackageSettings.map((item) => {
                        return item.id;
                    });

                    let ids = enrollmentPackageIds.concat(recurringPackageIds);

                    let requestData = {
                        pageNumber: 0,
                        itemsPerPage: 2147483647, // MAX Int32 value
                        criteria: {
                            includeActive: true,
                            filter: "%",
                            excludeIdList: [],
                            packageTypeIds: ids
                        }
                    };

                    this.dataService.customMethodData('/api/packagetype/List/', 'POST',requestData)
                        .then((response) => {
                            let enrollmentPackages = this.enrollmentPackageSettings.map((item) => {
                                let foundPackage = _.find(response.data,(itm:any)=>{
                                    return itm.id === item.id;
                                });

                                if(foundPackage) {
                                    item['services'] = foundPackage.services;
                                }

                                return item;
                            });

                            let recurringPackages = this.recurringPackageSettings.map((item:any) => {
                                let foundPackage = _.find(response.data,(itm:any)=>{
                                    return itm.id === item.id;
                                });

                                if(foundPackage) {
                                    item['services'] = foundPackage.services;
                                }

                                return item;
                            });

                            const options: Components.Modal.IModalOptions = {
                                templateUrl: 'app/plugins/membershipManager/sectionViews/viewBenefitsModalTemplate.html',
                                clickOutsideToClose: true,
                                locals: {
                                    benefits: data,
                                    membershipModel: membershipModel,
                                    enrollmentPackages: enrollmentPackages,
                                    recurringPackages: recurringPackages
                                },
                                controller: 'meevo.plugins.membershipManager.ViewBenefitsModalController',
                                controllerAs: 'vm'
                            };

                            this.params.modalService.showCustom(options);
                        }, (error) => {
                            console.log(error);
                        });
                });
        }

        private changePaymentValues() {
            if (this.model.isEmployeeMembership) {
                _.each(this.model.membershipMemberSettings, setting => {
                    setting.enrollmentFee = setting.enrollmentFee && 0;
                    setting.minEnrollmentFee = setting.minEnrollmentFee && 0;
                    setting.recurringFee = setting.recurringFee && 0;
                    setting.minRecurringFee = setting.minRecurringFee && 0;
                    setting.pifRenewalFee = setting.pifRenewalFee && 0;
                    setting.minPIFRenewalFee = setting.minPIFRenewalFee && 0;
                    setting.monthlyRenewalFee = setting.monthlyRenewalFee && 0;
                    setting.minMonthlyRenewalFee = setting.minMonthlyRenewalFee && 0;
                });
            }
        }

        private checkIsSold() {
            this.dataService
                .getCount('Membership/Client', { criteria: { MembershipId: this.model.id } })
                .then((count: number) => this.disableEmployeeMembership = !!count)
        }

        public autofillFeeValue(): void {
            let feeSettings = this.model.membershipMemberSettings[0];

            switch (this.model.billingTypeEnum) {
                case BillingTypeEnum.PaidInFull:
                    if (this.model.autoRenewTypeEnum === AutoRenewTypeEnum.PaidInFull
                        || this.model.autoRenewTypeEnum === AutoRenewTypeEnum.Both) {
                        if (!this.isPifRenewalFeeOverrided) {
                            feeSettings.pifRenewalFee = feeSettings.enrollmentFee;
                        }
                        if (!this.isMinPifRenewalFeeOverrided) {
                            feeSettings.minPIFRenewalFee = feeSettings.minEnrollmentFee;
                        }
                    }

                    break;
                case BillingTypeEnum.RecurringPayments:
                    if (!this.isRenewalFeeMonthlyOverrided) {
                        feeSettings.monthlyRenewalFee = feeSettings.recurringFee;
                    }
                    if (!this.isMinRenewalFeeMonthlyOverrided) {
                        feeSettings.minMonthlyRenewalFee = feeSettings.minRecurringFee;
                    }

                    break;
            }
        }

        public isFeeAutofilled(): void {
            let feeSettings = this.model.membershipMemberSettings[0];

            if (feeSettings.recurringFee != 0) {
                this.isRenewalFeeMonthlyOverrided = true;
            }
            if (feeSettings.minMonthlyRenewalFee != 0) {
                this.isMinRenewalFeeMonthlyOverrided = true;
            }
            if (feeSettings.pifRenewalFee != 0) {
                this.isPifRenewalFeeOverrided = true;
            }
            if (feeSettings.minPIFRenewalFee != 0) {
                this.isMinPifRenewalFeeOverrided = true;
            }
        }
        public updateBenefitsTemplate() {
            let membershipMemberSettings = this.model.membershipMemberSettings[0];
            if(membershipMemberSettings.membershipBenefitTemplateDetail === undefined) {
                membershipMemberSettings.membershipBenefitTemplateId = null;
            } else {
                membershipMemberSettings.membershipBenefitTemplateId = membershipMemberSettings.membershipBenefitTemplateDetail.id;
            }
        }

        /**
         * A package already picked for the recurring / renewal fee can be switched to unlimited before the membership
         * is saved. Returns the ids of the recurring / renewal packages about to be saved that are now unlimited.
         * Asks the same server check the save runs, so both see a switch made seconds ago.
         * If the lookup fails this resolves empty and logs it: the server runs the same check on save.
         * */
        public getUnlimitedRecurringRenewalPackageIds(): ng.IPromise<Array<string>> {
            const packageSettings = _.chain(this.getPackageSettingsToSave())
                .filter(item => item.feeType === Model.FeeTypeEnum.Recurring || item.feeType === Model.FeeTypeEnum.Renewal)
                .map(item => ({ feeType: item.feeType, packageTypeId: item.packageTypeId }))
                .value();

            if (packageSettings.length === 0) {
                return this.params.$q.resolve([]);
            }

            const lookupFailed = (error): Array<string> => {
                this.loggingService.error(`Membership ${this.model.id}: unlimited package check before save failed for package types ${_.pluck(packageSettings, 'packageTypeId').join(', ')}; the server check still applies.`, error);
                return [];
            };

            const uri = `/${this.dataService["appSettings"].API_ROOT}/packagetype/UnlimitedServices`;
            return this.dataService.customMethodData(uri, 'POST', { membershipPackageSettings: packageSettings })
                // ExceptionInterceptor resolves 300 / 409 / 410 error responses,
                // so a failure can arrive here as a "success" whose data is not the id list.
                .then((response) => _.isArray(response && response.data) ? response.data as Array<string> : lookupFailed(response),
                lookupFailed);
        }

        /**
         * Removes the given packages from the recurring and renewal fees the same way the remove icon does,
         * so the search box exception lists stay in step.
         * */
        public removeRecurringRenewalPackages(packageTypeIds: Array<string>): void {
            const isListed = (item: Model.IMembershipPackageSettings) => _.contains(packageTypeIds, item.packageTypeId);

            _.filter(this._recurringPackageSettings, isListed)
                .forEach(item => this.removePackage(item, this._recurringPackageSettings, this.recurringPackageExceptionList));
            _.filter(this._renewalPackageSettings, isListed)
                .forEach(item => this.removePackage(item, this._renewalPackageSettings, this.renewalPackageExceptionList));
        }

        public collectUnlimitedServicesIds(): ng.IPromise<any> {
            this.unlimitedServicesList = [];
            return this.dataService.getListPaged('packagetype', {
                itemsPerPage: 2147483647,
                criteria: {
                    'includeActive': true
                }
            }).then((data) => {
                data.forEach((item: any) => {
                    if (item.isUnlimitedServices) {
                        this.unlimitedServicesList.push(item);
                    }
                });
            });
        }

        public isExpireServicesToggleDisabled(): boolean {
            if (!this.model) return false;

            if (this.model.membershipLengthEnum === MembershipLengthEnum.Days) {
                this.model.isAccruedServiceDaysToExpireEnabled = false;
                this.model.accruedServiceDaysToExpire = 30;
                return true;
            } else if (this.model.locationId != this.model.homeLocationId && this.model.isAccruedServiceDaysToExpireEnabledAtCO) {
                return true;
            } else {
                return false;
            }
        }

        public changeExpireServicesToggle(): void {
            if (!this.model.isAccruedServiceDaysToExpireEnabled) {
                this.model.accruedServiceDaysToExpire = 30;
            }
        }

        public excludeSpecificServicesToggle(): void {
            if (!this.model.isExcludeSpecificServicesFromTransfer) {
                this.model.excludedServicesFromTransfer = [];
            }
        }

        public isShowPIFNote(isModeCO: boolean): boolean {
            const onlineMembershipSettings = this.dataService["appSettings"].APP_BUSINFOSETTINGS.onlineMembershipSettings;
            const onlineMembershipSalesEnabled = (
                isModeCO
                ? onlineMembershipSettings.enableCOOnlineMembershipSales
                : onlineMembershipSettings.enableOnlineMembershipSales
            );
            const showPIFNote = onlineMembershipSalesEnabled
                && this.model.isAvailableForOnlineSales
                && this.model.billingTypeEnum == BillingTypeEnum.PaidInFull
                && this.model.membershipLengthEnum == MembershipLengthEnum.Months
                && this.model.membershipLength > 1;
            
            return showPIFNote;
        }
    }
}
